/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListCustomerLightningPaymentsRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {ListCustomerLightningPaymentsResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const listCustomerLightningPayments = (request: ListCustomerLightningPaymentsRequest, options?: CashRequestOptions) => post<ListCustomerLightningPaymentsRequest, ListCustomerLightningPaymentsResponse>("/2.0/cash/list-customer-lightning-payments", request, {...options, rejectOnError: true })